import { useLocale } from "./useLocale.js";
import { LocaleSettingsPanel } from "./LocaleSettingsPanel.js";
import { Modal } from "../ui/Modal";
import { IconButton } from "../ui/IconButton";

export function LocaleSettingsModal({ onClose }) {
  const { display } = useLocale();

  return (
    <Modal
      titleId="locale-settings-title"
      onClose={onClose}
      className="modal locale-settings-modal"
      header={(
        <div className="modal-title">
          <div>
            <h2 id="locale-settings-title">{display.t("web.settings.title")}</h2>
            <p>{display.t("web.settings.intro")}</p>
          </div>
          <IconButton label={display.t("web.shell.closeNotice")} onClick={onClose}>×</IconButton>
        </div>
      )}
    >
      <LocaleSettingsPanel />
      <div className="modal-actions">
        <button type="button" className="primary-button" onClick={onClose}>
          {display.t("common.save")}
        </button>
      </div>
    </Modal>
  );
}
